export const state = {
  apps: [],
}

export const getters = {
  allApps(state) {
    return state.apps
  },
  favoriteApps(state) {
    return state.apps.filter((app) => app.isFavorite)
  },
  isAppFavorite(state, getters) {
    return (appId) => getters.favoriteApps.some((app) => app.appId === appId)
  },
}

export const mutations = {
  SET_APPS(state, apps) {
    state.apps = apps
  },

  FAVORITE_APP_BY_ID(state, appId) {
    const appToBeFavorite = state.apps.find((app) => app.appId === appId)
    appToBeFavorite.isFavorite = true
    appToBeFavorite.favoritedAt = new Date().toISOString()
  },

  UNFAVORITE_APP_BY_ID(state, appId) {
    const appToBeUnfavorite = state.apps.find((app) => app.appId === appId)
    appToBeUnfavorite.isFavorite = false
    appToBeUnfavorite.favoritedAt = null
  },
}
